import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';


const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    width: '100%',
    right: 'auto',
    backgroundColor: 'transparent'
  },
  menuButton: {
    width: '100%',
    justifyContent: "flex-end",
    display: 'flex',
    alignItems: 'inherit'
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;
  const classes = useStyles();
  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Hidden mdUp>
        <div className={classes.menuButton}>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon style={{ color: '#191919', boxShadow: "0px 0px 6px 1px #b6b6b6", borderRadius: "0px", fontSize: '2.5rem', marginLeft: '5px', marginTop: '2px' }} />
          </IconButton>
        </div>
      </Hidden>
    </AppBar>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func
};

export default Topbar;